import { useQuery } from '@tanstack/react-query';
import { BarChart3 } from 'lucide-react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { apiClient } from '@/lib/api-client';
import { CardShell, EmptyState } from '../cards/card-shell';
import { formatSource } from './chart-colors';

export function TopSourcesWidget() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['clients', 'stats', 'charts'],
    queryFn: () => apiClient.clientsStatsCharts(),
    staleTime: 1000 * 60,
  });

  const rows = (data?.topSources ?? []).map((s) => ({
    label: formatSource(s.source),
    count: s.count,
  }));

  return (
    <CardShell title="Origem dos contatos" icon={BarChart3}>
      <div className="h-full w-full">
        {isLoading ? (
          <div className="h-full w-full animate-pulse rounded bg-[var(--surface-muted)]/40" />
        ) : isError ? (
          <p className="text-xs text-[var(--fg-muted)]">
            Não foi possível carregar.
          </p>
        ) : rows.length === 0 ? (
          <EmptyState
            icon={BarChart3}
            message="Nenhuma origem registrada ainda."
          />
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={rows}
              margin={{ top: 8, right: 8, left: -16, bottom: 0 }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="var(--border)"
                vertical={false}
              />
              <XAxis
                dataKey="label"
                stroke="var(--fg-muted)"
                fontSize={11}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                stroke="var(--fg-muted)"
                fontSize={11}
                tickLine={false}
                axisLine={false}
                allowDecimals={false}
              />
              <Tooltip
                cursor={{ fill: 'var(--surface-muted)', opacity: 0.4 }}
                contentStyle={{
                  background: 'var(--surface)',
                  border: '1px solid var(--border)',
                  borderRadius: 8,
                  fontSize: 12,
                  color: 'var(--fg)',
                }}
                labelStyle={{ color: 'var(--fg)' }}
                itemStyle={{ color: 'var(--fg)' }}
              />
              <Bar dataKey="count" fill="var(--accent)" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </CardShell>
  );
}
